'use strict';

//const Actions = require('./actions');
import React from 'react';

import Signin from './sign-in';
import PropTypes from 'prop-types';

const propTypes = {
    login: PropTypes.object,
    signinComplete: PropTypes.func
};

class SignInAfterRegister extends React.Component {
    constructor(props) {

        super(props);

        //this.input = {};
    }

    render() {

        return (
            <section className="sor">
                <h3 className="text-center">Sign In</h3>
                <p className="text-center sign-in-or-register-text">Congratulations!  Please confirm your email and password by signing in now.</p>
                <Signin signinComplete={this.props.signinComplete} {...this.props.login} />
            </section>
        );
    }
}

SignInAfterRegister.propTypes = propTypes;

export default SignInAfterRegister;
